import { NgModule } from "@angular/core"
import { ExtraOptions, RouterModule, Routes } from "@angular/router"
import { LoginRequiredComponent } from "./error/login-required/login-required.component"
import { NotAuthGuard } from "./guards/NotAuth.guard"
import { TeacherAuthGuard } from "./guards/TeacherAuth.guard"
import { LaunchAssignmentProxy } from "./error/launch-assignment-proxy/launch-assignment-proxy.component"
import { AssignmentResultsProxyComponent } from "./error/assignment-results-proxy/assignment-results-proxy.component"
import { SetTeacherExperienceGuard } from "./guards/SetTeacherExperience.guard"

const appRoutes: Routes = [
    { path: "", loadChildren: "./homepage/homepage.module#HomepageModule" },
    {
        path: "admin/design-system",
        loadChildren: "./design-system/design-system.module#DesignSystemModule",
    },
    { path: "subjects", pathMatch: "full", redirectTo: "/" },
    {
        path: "subjects",
        loadChildren: "./browsing/browsing.module#BrowsingModule",
    },
    { path: "grades", pathMatch: "full", redirectTo: "/" },
    {
        path: "grades",
        loadChildren:
            "./browse-by-grade/browse-by-grade.module#BrowseByGradeModule",
    },
    {
        path: "resource",
        loadChildren: "./resource/resource.module#ResourceModule",
    },
    {
        path: "search",
        loadChildren: "./search-page/search-page.module#SearchPageModule",
    },
    { path: "error", loadChildren: "./error/error.module#ErrorModule" },
    {
        path: "student/launch_assignment_proxy/:assignmentCode/:rosterCode",
        component: LaunchAssignmentProxy,
    },
    {
        path:
            "tools/rosters/results/assignment_results_proxy/:assignmentCode/:rosterCode/:resultId",
        component: AssignmentResultsProxyComponent,
    },
    { path: "student", loadChildren: "./embed/embed.module#EmbedModule" },
    { path: "loginRequired", component: LoginRequiredComponent },
    {
        path: "signup",
        loadChildren: "./signup/signup.module#SignupModule",
        canActivate: [NotAuthGuard, SetTeacherExperienceGuard],
    },

    // Feature flag routes. Order is important
    {
        path: "profile",
        loadChildren: "./user-profile/user-profile.module#UserProfileModule",
        canActivate: [TeacherAuthGuard],
    },

    {
        path: "collection",
        loadChildren: "./collection/collection.module#CollectionModule",
    },

    // Feature flag routes end.
    { path: "**", loadChildren: "./embed/embed.module#EmbedModule" },
]

const extraRouteConfig: ExtraOptions = { onSameUrlNavigation: "reload" }

@NgModule({
    imports: [RouterModule.forRoot(appRoutes, extraRouteConfig)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
